import AccessibilityHelper from '../lib/AccessibilityHelper.js';
import el from '@finn-no/create-element';
import { toast } from '@finn-no/common-browserbundle';

export default {
    dependencies: ['$element', 'trackingservice'],
    callable(ele, trackingService) {
        const state = {
            notSupported: false,
            isSubscribed: false,
            loading: false,
            firstRender: true,
        };
        const buttonStyle = ele.querySelector('button').style.cssText;

        // prettier-ignore
        // VAPID public key
        const applicationServerKey = new Uint8Array([
            0x04, 0x59, 0xff, 0x1b, 0x7b, 0x49, 0x3c, 0x0a, 0xfe, 0x5d, 0x37, 0xe5, 0xc0, 0xea, 0x21,
            0xc0, 0xd2, 0x81, 0x89, 0x9a, 0xfe, 0x61, 0x3c, 0x26, 0x69, 0x7d, 0xce, 0xba, 0x44, 0x07,
            0xb6, 0x83, 0xd0, 0x74, 0x0a, 0xc5, 0xec, 0x66, 0x17, 0x19, 0x03, 0x49, 0xb5, 0x29, 0xb6,
            0x12, 0xb3, 0xce, 0x21, 0x35, 0xa6, 0x21, 0x94, 0x3f, 0x4a, 0x77, 0x20, 0xac, 0xdb, 0xd0,
            0x12, 0x18, 0x8c, 0xbe, 0xcd,
        ]);

        init();

        function getSubscription() {
            return navigator.serviceWorker.ready.then(reg =>
                reg.pushManager.getSubscription()
            );
        }

        function subscribe(registration) {
            return registration.pushManager
                .subscribe({
                    userVisibleOnly: true,
                    applicationServerKey,
                })
                .then(registerPush)
                .catch(handleSubscribeFailure);
        }

        function unsubscribe() {
            return getSubscription().then(sub => {
                if (sub) {
                    return sub.unsubscribe();
                }
                return Promise.resolve();
            });
        }

        function registerPush(sub) {
            const body = new URLSearchParams();
            body.append('subscription', JSON.stringify(sub));
            body.append(
                'csrfToken',
                document.querySelector("meta[name='csrf-token']").content
            );
            return fetch('/settings/register-push-subscription.json', {
                method: 'POST',
                credentials: 'same-origin',
                body,
            })
                .then(response => {
                    state.loading = false;
                    if (!response.ok) {
                        return Promise.reject();
                    }
                    state.isSubscribed = true;
                    render();
                    toast({
                        level: 'success',
                        message: 'Varslinger er nå aktivert.',
                    });
                })
                .catch(handleRegisterFailure); // network failure
        }

        function handleUnsubscribe() {
            state.isSubscribed = false;
            state.loading = false;
            render();
        }

        // The browser couldn't get a subscription
        function handleSubscribeFailure(error) {
            if (Notification.permission === 'denied') {
                toast({
                    level: 'error',
                    node: el(
                        'div',
                        null,
                        'Det ser ut som du har blokkert FINN.no fra å gi varslinger i nettleseren.',
                        ' ',
                        el(
                            'a',
                            {
                                href:
                                    'https://hjelpesenter.finn.no/hc/no/articles/115004583289-Varslinger-i-nettleseren',
                                target: '_blank',
                            },
                            'Endre innstillingene i nettleseren'
                        ),
                        ' og forsøk igjen.'
                    ),
                    timeout: 10000,
                });
            } else {
                toast({
                    level: 'error',
                    message: 'Usjda, noe gikk galt. Prøv på nytt litt senere.',
                    timeout: 10000,
                });
                if (window.trackJs) {
                    window.trackJs.track(
                        `Unable to subscribe to push notifications: ${error}`
                    );
                }
            }
            state.loading = false;
            render();
        }

        // Registering the subscription with the backend failed
        function handleRegisterFailure() {
            // Unsubscribe, otherwise the browser has a subscription, but the backend doesn't.
            unsubscribe().then(handleUnsubscribe);
            toast({
                level: 'error',
                message: 'Usjda, noe gikk galt. Prøv på nytt litt senere.',
                timeout: 10000,
            });
        }

        function render() {
            let content;
            if (state.notSupported) {
                content = renderUnsupportedButton();
            } else if (state.isSubscribed) {
                content = renderUnsubscribeButton();
            } else {
                content = renderSubscribeButton();
            }

            ele.textContent = '';
            ele.append(content);
            if (!state.firstRender) {
                AccessibilityHelper.focusFirst(ele);
            }
        }

        function renderUnsupportedButton() {
            return el(
                'button',
                { disabled: true, style: buttonStyle },
                'Din nettleser støtter ikke varslinger'
            );
        }

        function renderSubscribeButton() {
            return el(
                'button',
                {
                    style: buttonStyle,
                    onclick: handleSubscribeClick,
                    class: state.loading ? 'inprogress' : null,
                    disabled: state.loading,
                },
                'Slå på for denne enheten'
            );
        }

        function renderUnsubscribeButton() {
            return el(
                'button',
                {
                    style: buttonStyle,
                    onclick: handleUnsubscribeClick,
                    class: state.loading ? 'inprogress' : null,
                    disabled: state.loading,
                },
                'Slå av for denne enheten'
            );
        }

        function handleSubscribeClick() {
            navigator.serviceWorker.ready.then(subscribe);
            state.loading = true;
            render();
            trackingService.trackEvent(
                'notifications.web-push-subscribe.click'
            );
        }

        function handleUnsubscribeClick() {
            unsubscribe().then(handleUnsubscribe);
            state.loading = true;
            render();
            trackingService.trackEvent(
                'notifications.web-push-unsubscribe.click'
            );
        }

        function init() {
            if (!navigator.serviceWorker) {
                state.notSupported = true;
                render();
                state.firstRender = false;
                return;
            }

            getSubscription().then(sub => {
                state.isSubscribed = sub != null;
                render();
                state.firstRender = false;
            });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/pushSubscribe.js